import type { LearnPracticalContent } from "../practicalContent.js";

export const publicSafetyContent: LearnPracticalContent = {
  th: {
    notice: [
      "เสียงอาวุธ การทำร้าย หรือคำเตือนจากเจ้าหน้าที่ต้องประเมินจากสิ่งที่เห็นและได้ยินจริง",
      "ทางเลือกขึ้นกับตำแหน่งของภัย ทางออก และสถานที่ ไม่ใช่ขั้นตอนตายตัว",
      "ข้อมูลในโซเชียลอาจคลาดเคลื่อน ให้แยกสิ่งที่สังเกตเองออกจากข่าวลือและประกาศที่ยังไม่ยืนยัน",
      "เมื่ออยู่ในสถานที่ใหม่ การเห็นทางออก จุดรวมพล เจ้าหน้าที่ และพื้นที่ที่มีคนมากช่วยให้ตัดสินใจได้เร็วขึ้นหากเกิดเหตุ",
    ],
    prepare: [
      "เมื่อเข้าสถานที่ ให้สังเกตทางออกและจุดที่ขอความช่วยเหลือได้",
      "ตกลงวิธีติดต่อและจุดนัดพบกับคนที่มาด้วยกัน",
      "รู้ว่าจะแจ้งเจ้าหน้าที่ของสถานที่อย่างไร และตั้งโทรศัพท์ให้ปิดเสียงได้รวดเร็ว",
      "ตั้งชื่อและจุดนัดพบที่คนในกลุ่มเข้าใจร่วมกัน แต่ไม่ต้องแชร์ตำแหน่งแบบสาธารณะเมื่ออาจเพิ่มความเสี่ยง",
    ],
    during: [
      "ถ้ามีทางปลอดภัย ให้ออกจากพื้นที่อันตราย",
      "ถ้าออกไม่ได้ ให้ซ่อนในที่มั่นคง ปิดเสียงโทรศัพท์ และติดต่อเจ้าหน้าที่เมื่อพ้นการมองเห็นหรือได้ยินของผู้ก่อเหตุ",
      "เมื่อเจ้าหน้าที่มาถึง ให้วางสิ่งของในมือ แสดงมือให้เห็น และทำตามคำสั่งแม้ยังไม่ได้รับคำอธิบาย",
      "ถ้าเหตุเกี่ยวข้องกับฝูงชนหรือความขัดแย้ง ให้เพิ่มระยะห่าง เลี่ยงทางตัน และออกโดยไม่ผลักหรือย้อนเข้าไปดูเหตุ",
    ],
    avoid: [
      "อย่าเข้าใกล้ ติดตาม ถ่ายภาพ หรือพยายามแทรกแซงเหตุ",
      "การต่อต้านเป็นทางเลือกสุดท้ายเมื่อเผชิญภัยโดยตรงและไม่มีทางหนีหรือซ่อน",
      "อย่าหยุดเอาทรัพย์สิน อย่ารวมกลุ่มขวางทางออก และอย่าเผยแพร่ตำแหน่งผู้หลบซ่อนแบบสาธารณะ",
      "อย่าส่งต่อภาพ ชื่อ หรือข้อกล่าวหาที่ระบุตัวบุคคลโดยไม่ยืนยัน เพราะอาจทำให้ข้อมูลผิดแพร่กระจายและเพิ่มอันตราย",
    ],
    help: [
      "เมื่อปลอดภัยแล้ว แจ้งตำแหน่ง ลักษณะเหตุ และข้อมูลที่สังเกตได้แก่เจ้าหน้าที่",
      "ทำตามคำสั่งตำรวจและแสดงมือให้เห็นเมื่อเจ้าหน้าที่เข้าพื้นที่",
      "ผู้บาดเจ็บ ผู้ที่แยกจากครอบครัว หรือผู้ที่รู้สึกไม่ปลอดภัยหลังเหตุควรขอความช่วยเหลือจากเจ้าหน้าที่หรือบริการที่เหมาะสม",
      "หากอยู่ในเหตุแต่ไม่บาดเจ็บ ให้ติดต่อคนใกล้ชิดเมื่อปลอดภัยด้วยข้อความสั้น และดูแลความเครียดหรืออาการนอนไม่หลับที่ต่อเนื่องกับผู้เชี่ยวชาญ",
    ],
    example:
      "ได้ยินเสียงคล้ายอาวุธในสถานที่สาธารณะ: หากเห็นทางออกที่ปลอดภัยให้ออกห่าง หากออกไม่ได้ให้หาที่กำบังและปิดเสียงโทรศัพท์ แจ้งเจ้าหน้าที่เมื่อทำได้อย่างปลอดภัย",
    situations: [
      {
        title: "ห้างหรือสถานี",
        text: "สังเกตทางออกเมื่อมาถึง หากเกิดเหตุให้เลือกออกหรือหลบตามอันตรายจริง ไม่กลับไปตามเพื่อนหรือทรัพย์สินในจุดเสี่ยง",
      },
      {
        title: "งานอีเวนต์",
        text: "ตั้งจุดนัดพบกับคนในกลุ่มล่วงหน้าและใช้ข้อความสั้นเมื่อปลอดภัย แทนการโพสต์ตำแหน่งแบบสาธารณะ",
      },
      {
        title: "ข้อมูลในมือถือ",
        text: "ใช้ประกาศของสถานที่และเจ้าหน้าที่เป็นหลัก ไม่แชร์ข่าวด่วน ภาพ หรือชื่อบุคคลที่ยังไม่ยืนยัน",
      },
    ],
    checklist: [
      "สังเกตทางออกเมื่อเข้าพื้นที่",
      "เลือกออกหรือซ่อนตามอันตรายจริง",
      "ปิดเสียงโทรศัพท์เมื่อหลบซ่อน",
      "แจ้งเฉพาะสิ่งที่เห็นกับเจ้าหน้าที่",
      "แสดงมือและทำตามคำสั่งตำรวจ",
      "ไม่เผยแพร่ตำแหน่งผู้หลบซ่อน",
      "ส่งข้อความสั้นเมื่อปลอดภัย",
    ],
  },
  en: {
    notice: [
      "Weapons, assault, or an official warning must be judged from what is actually seen and heard.",
      "Options depend on the threat, exits, and venue; they are not a rigid sequence.",
      "Social posts may be wrong; separate what you observed from rumours and unconfirmed alerts.",
      "At a new venue, noticing exits, assembly points, staff, and crowded areas can support faster decisions if something happens.",
    ],
    prepare: [
      "Notice exits and places to seek help when entering a venue.",
      "Agree on a contact method and meeting point with companions.",
      "Know how to alert venue staff and how to silence your phone quickly.",
      "Agree on a group name and meeting point without publicly sharing a location when that could increase risk.",
    ],
    during: [
      "If a safe route exists, leave the danger area.",
      "If escape is unsafe, hide in a secure place, silence the phone, and contact police when out of the attacker's sight and hearing.",
      "When officers arrive, put down items, keep hands visible, and follow instructions even before an explanation is available.",
      "For a crowd or confrontation, create distance, avoid dead ends, and leave without pushing or returning to watch the incident.",
    ],
    avoid: [
      "Do not approach, follow, film, or try to intervene.",
      "Physical resistance is a last resort only under direct threat when escape and hiding are unavailable.",
      "Do not stop for belongings, crowd an exit, or publicly post the location of people who are hiding.",
      "Do not circulate images, names, or allegations identifying individuals without confirmation; it can spread false information and increase danger.",
    ],
    help: [
      "When safe, tell police the location, nature of the incident, and only what you observed.",
      "Follow police instructions and keep hands visible when officers enter.",
      "Injured people, separated household members, or anyone who feels unsafe afterward should seek suitable responder or support help.",
      "If you were involved but uninjured, send a short safe-status message when able and seek professional support for persistent stress or sleep problems.",
    ],
    example:
      "You hear what may be a weapon in a public venue: leave by a safe exit if one is clear. If not, find secure shelter, silence your phone, and contact police when safe.",
    situations: [
      {
        title: "Mall or station",
        text: "Notice exits on arrival. If an incident happens, leave or shelter based on the actual threat; do not return for companions or belongings in a danger area.",
      },
      {
        title: "Event",
        text: "Agree on a meeting point in advance and send a short status message when safe instead of posting your location publicly.",
      },
      {
        title: "Phone information",
        text: "Use venue and responder updates as your main source. Do not share urgent posts, images, or names that have not been confirmed.",
      },
    ],
    checklist: [
      "Notice exits on arrival",
      "Choose escape or shelter based on the actual threat",
      "Silence the phone while hiding",
      "Report only observations",
      "Keep hands visible for police",
      "Do not post a hiding location publicly",
      "Send a short safe-status message",
    ],
  },
};
